// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import Messages from '@app/features/messaging/state/Messages';
import CountryCode from '@app/features/user/state/CountryCode';

interface ResumedPayload {
	country_code?: string;
	latitude?: string;
	longitude?: string;
}
export function handleResumed(data: unknown, context: GatewayHandlerContext): void {
	if (typeof data === 'object' && data !== null) {
		const payload = data as ResumedPayload;
		if (payload.country_code) {
			CountryCode.setCountryCode(payload.country_code);
		}
		context.setConnectionGeoip({
			country_code: payload.country_code,
			latitude: payload.latitude,
			longitude: payload.longitude,
		});
	}
	Messages.handleResumed();
}
